export default __webpack_public_path__ + "static/media/Cigars.2292958c.png";